import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

import { environment } from '@environments/environment';
import * as FileSaver from 'file-saver';
import * as moment from 'moment';

import { UiService } from './ui.service';

@Injectable({
  providedIn: 'root'
})
export class TemperaturesService {
  private baseUrl: string = environment.apiUrl + 'temperatures';

  constructor(
    private http: HttpClient,
    private uiSrv: UiService
  ) { }

  downloadKooveaPDF(startDate: Date, endDate: Date, tag: string, clientId: string): Observable<Blob> {
    let start = moment(new Date(startDate)).utc().format("YYYY-MM-DD HH:mm:ss")
    let end = moment(new Date(endDate)).utc().format("YYYY-MM-DD HH:mm:ss")
    this.uiSrv.loadingStateChanged.next(true);

    return this.http.get(`${this.baseUrl}/pdf?startDate=${start}&endDate=${end}&tag=${tag}&&clientId=${clientId}`, { observe: 'response', responseType: 'blob' })
      .pipe(
        catchError(err => {
          console.log("error", err);
          if (err.status) {
            this.uiSrv.showSnackbar('Pas de sonde de T° active sur cet objet', false, 5000);
          }
          return throwError(err);
        }),
        map((res: any) => {
          if (res?.apiCode && res?.apiCode === 401) {
            this.uiSrv.showSnackbar("Le tag n'a pas été retrouvé sur Koovea", false, 5000)
          } else {
            return this.saveFile(res)
          }
        })
      );
  }

  private saveFile(res: HttpResponse<Blob>): Blob {
    FileSaver.saveAs(res.body, res.headers.get('filename'));
    return res.body;
  }

}
